import {Stammdatum} from './stammdatum';

export class Stammdaten {
  status: Stammdatum[];
  grundgesamtheit: Stammdatum[];
  ausbildung: Stammdatum[];
  beruflicheStellung: Stammdatum[];
  beruflichesKompetenzniveau: Stammdatum[];
  buwaz: Stammdatum[];
  geschlecht: Stammdatum[];
  funktionen: Stammdatum[];
}
